@let vState = state();
<div class="dialog-header">
  <hgroup>
    <h2 class="heading-xl">Share your availability</h2>
  </hgroup>
  <button class="button tertiary" (click)="availabilityChange.emit()">
    <div class="icon icon-x"></div>
    <span class="sr-only" i18n>Close</span>
  </button>
</div>
<p class="dialog-intro body-copy-md">
  Please select the dates you are available for this trip. You can always change your availability later.
</p>
@if (vState) {
  <div
    #errorSummary
    id="errorSummary"
    aria-live="polite"
    aria-atomic="true"
    tabindex="-1"
    class="form-errors">
    @if (vState.error) {
      <div class="form-error">
        <div class="icon icon-alert-circle"></div>
        <p class="error-message">{{ vState.error }}</p>
      </div>
    }
  </div>
  @if (datesState()) {
      <at-multi-select-calendar
          [(selected)]="selectedDates"
          [minDate]="startDate()"
          [maxDate]="endDate()"
          [dateFilter]="dateFilter()"></at-multi-select-calendar>
  }
  <div class="selection">
      <button class="button quaternary" (click)="selectAll()">Select all</button>
      <button class="button quaternary" (click)="clearAll()">Deselect all</button>
  </div>
  <div class="dialog-buttons-host">
    <button class="button primary" [disabled]="vState.isLoading" (click)="save.next()">Save availability</button>
    <button class="button tertiary" [disabled]="vState.isLoading" (click)="availabilityChange.emit()">Cancel</button>
  </div>
}